<template>
  <item-container v-if="combatant" :loaded="loaded">
    <template v-slot:default>
      <display-field
        :readonly="true"
        :primary="true"
        :value="combatant.name || `unnamed`"
      ></display-field>

      <span class="ml-1">
        <stats-link
          collection="combatants"
          title="View combatant stats"
          :id="id"
          :class="[$options.$styles.iconButtons, ` max-md:py-2 `]"
        >
          stats
        </stats-link>
      </span>

      <div class="flex-0 flex justify-end relative ml-4" v-if="battle">
        <div class="">
          <button
            class="o-obvious-button whitespace-no-wrap -ml-px max-md:py-1"
            type="button"
            v-if="!inCurrentBattle"
            @click="addHandler"
          >
            <span class="sm:hidden text-lg">+</span
            ><span class="max-sm:hidden"
              >to<span class="hidden lg:inline"> current</span> battle</span
            >
          </button>

          <div v-else class="text-xs leading-none py-75p px-1 uppercase ">
            <span class="mr-px text-accent">✔︎ </span>added to current battle
          </div>
        </div>
      </div>
    </template>

    <template v-slot:after>
      <button
        class="bg-transparent button-reset hover:bg-transparent hover:opacity-100 hover:text-accent o-button opacity-40 t text-accent py-4"
        @click="destroy"
        title="Remove from favourites"
      >
        ×
      </button>
    </template>
  </item-container>
</template>

<script>
import StatsLink from '@/components/StatsLink'
import DisplayField from '@/components/DisplayField'
import ItemContainer from '@/components/ItemContainer'
import { mapActions, mapGetters } from 'vuex'
import { db } from '@/utilities/db-helpers'
import { iconButtons } from '@/utilities/styles'

export default {
  name: `Favourite`,
  components: {
    StatsLink,
    DisplayField,
    ItemContainer,
  },
  props: [`id`],
  data: () => ({
    combatant: {},
  }),
  computed: {
    ...mapGetters(`battles`, [`battle`]),

    loaded() {
      return this.combatant
    },

    inCurrentBattle() {
      return (
        this.loaded &&
        Object.keys(this.combatant.battles || {}).includes(this.battle)
      )
    },
  },
  methods: {
    ...mapActions(`battle`, [`addCombatant`]),
    ...mapActions(`combatant/sheet`, [`bindCombatantRef`]),
    ...mapActions(`favourites`, [`addToBattle`, `unfave`]),

    destroy() {
      if (confirm(`Wannae ge’it tae fuck, aye?`)) {
        this.unfave(this.combatant)
      }
      return
    },

    addHandler() {
      this.addToBattle({ id: this.id })
    },

    async bindData(id) {
      await db
        .ref(`/combatants/${id}`)
        .on(`value`, snapshot => (this.combatant = snapshot.val()))
    },
  },
  created() {
    this.bindData(this.id)
  },
  $styles: {
    iconButtons,
  },
}
</script>
